import { render } from "./StepWrapper.vue?vue&type=template&id=51b998f6"
import script from "./StepWrapper.vue?vue&type=script&lang=js"
export * from "./StepWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__